import React from 'react';
import styled from 'styled-components';
import { styles } from '../../../styles/themes/style';

interface IInviteJoinTitleProps {
    workspaceName?: string | null;
    className?: string;
}

export const InviteJoinTitle: React.FC<IInviteJoinTitleProps> = ({ workspaceName, className }) => {
    const name = workspaceName?.trim() || 'workspace';

    return (
        <JoinTitleBlock className={className}>
            <JoinLabel>Join</JoinLabel>
            <WorkspaceNameLine title={name}>{name}</WorkspaceNameLine>
        </JoinTitleBlock>
    );
};

interface IInviteWorkspaceNameProps {
    children: string;
    className?: string;
}

/** Compact workspace name for cards and inline contexts. */
export const InviteWorkspaceName: React.FC<IInviteWorkspaceNameProps> = ({ children, className }) => (
    <WorkspaceNameCompact className={className} title={children}>
        {children}
    </WorkspaceNameCompact>
);

const JoinTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
    min-width: 0;
`;

const JoinLabel = styled.span`
    font-family: NunitoSans;
    font-weight: 700;
    font-size: 32px;
    line-height: 32px;
    color: ${styles.colors.black600};
`;

const WorkspaceNameLine = styled.span`
    font-family: NunitoSans;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: ${styles.colors.black400};
    width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const WorkspaceNameCompact = styled.span`
    font-family: NunitoSans;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: ${styles.colors.black600};
    width: 100%;
    min-width: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
`;

export default InviteJoinTitle;
